import mutations from './pregnancyForm.mutations'
import actions from './pregnancyForm.actions'
import getters from './pregnancyForm.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
